import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Container } from "@/components/Container";
import { usePersonaQuery } from "@/api/personas.ts";
import { useToast } from "@/hooks/use-toast";
import { ChevronLeftIcon, LoaderCircle } from "lucide-react";
import MintTokenForm from "@/components/MintTokenComponents/MintTokenForm";
import { usePrivy } from "@privy-io/react-auth";
import { H4 } from "@/components/ui/h4";
import { useNavigate } from "react-router-dom";

const MintTokenPage = () => {
  const { personaId } = useParams();
  const { toast } = useToast();
  const { authenticated } = usePrivy();
  const navigate = useNavigate();
  const {
    data: persona = undefined,
    isError,
    isFetching,
  } = usePersonaQuery(authenticated, personaId ?? "");

  const personaData = persona ?? {
    persona_id: "",
    avatar_id: "",
    name: "",
    web3: { contractAddress: "", cluster: "mainnet-beta" },
    gender: "male",
  };

  const contractAddress = personaData?.web3?.contractAddress || "";

  const pageTitle = `Mint ${persona?.name ?? persona?.persona_id}'s Token`;

  useEffect(() => {
    if (isError) {
      toast({ description: "Error loading agent or documents" });
    }
  }, [isError, toast]);

  useEffect(() => {
    if (!isFetching && contractAddress) {
      navigate(`/agents/${personaId}`);
    }
  }, [contractAddress, navigate, personaId, isFetching]);

  // Show loading spinner while fetching data
  if (isFetching) {
    return (
      <div className="flex items-center justify-center h-screen">
        <LoaderCircle className="h-12 w-12 animate-spin text-primary" />
      </div>
    );
  }

  if (contractAddress) {
    return null;
  }

  return (
    <Container className="relative">
      {/* Header with Back Button */}
      <div className="relative w-full flex flex-row justify-between items-center mb-8">
        <Link to={`/agents/${personaId}`}>
          <Button
            className="hidden sm:flex flex-row gap-x-2 text-primary"
            variant="ghost"
          >
            <ChevronLeftIcon /> Back
          </Button>
        </Link>
      </div>

      {/* Main Content */}
      <div className="space-y-8">
        {/* Page Title */}
        <H4 className="text-[#E2FF67] text-center font-medium mb-8">
          {pageTitle}
        </H4>

        {/* Form Container with Dark Background */}
        <div className="bg-[#121212] rounded-lg p-8 w-full mx-auto">
          <MintTokenForm
            // @ts-expect-error the defaulting is wrong
            personaData={personaData}
          />
        </div>
      </div>
    </Container>
  );
};

export default MintTokenPage;
